const closeIcon = (classes) => `<svg class="${classes}" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8125 6.1875L6.1875 15.8125M15.8125 15.8125L6.1875 6.1875L15.8125 15.8125Z" stroke="#78716C" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

export default closeIcon;
